import useSWR from "swr";
import { createProductServiceAxiosClient } from "../createProductServiceAxiosClient.ts";
import {
  HeyLightConfigDTO,
  StripeConfigDTO,
} from "../../NormasTeachingCheckout/PaymentMethodConfiguration.ts";
import { KnownProduct } from "../../Admin/Product/KnownProduct.tsx";
import { FPSProductInfo } from "./useCreateNormasTeachingProduct.ts";
export enum Currency {
  Eur = "EUR",
}

export type MoneyDTO = {
  amount: number;
  currency: Currency;
};

export type ShortProductDTO = {
  productClass: KnownProduct;
  productName: string;
  _id: string;
};

export type NormasTeachingProductDTO = {
  _id: string;
  priceInCents: MoneyDTO;
  productName: string;
  productClass: KnownProduct;
  productDescription?: string;
  fpsProductInfo?: FPSProductInfo;
  variantProductName: string;
  bundledProducts: ShortProductDTO[];
  peopleCount: number;
  purchaseAcTags: string[];
  refundAcTags: string[];
  stripeConfig?: StripeConfigDTO;
  heylightConfig?: HeyLightConfigDTO;
  analyticsTag?: string;
  isCouponEnabled: boolean;
  /** Absent on products created before the flag existed, which are enabled. */
  isEnabled?: boolean;
};

export function useNormasTeachingProductById(productId: string) {
  const { data, isLoading } = useSWR(`/products/${productId}`, async (url) => {
    const { data } =
      await createProductServiceAxiosClient().get<NormasTeachingProductDTO>(
        url,
      );
    return data;
  });

  return {
    product: data,
    isLoading,
  };
}
